import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  RadioGroup,
  Stack,
  Radio
} from '@chakra-ui/react'
import { FC } from 'react'
import { FaTruck } from 'react-icons/fa'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useReabRoutes from '@hook/parametrization/use-reab-routes'
import useReabTypeVeichule from '@hook/parametrization/use-reab-typeveichule'
import useFilters from '@hook/shared/use-filters'

import Filter from '@component/Shared/Filter'

const ReabRoutesCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    loadingEdit,
    clearParams,
    paramsEdit,
    selected,
    handleUpdateEditParams,
    createData
  } = useReabRoutes()
  const { centers, distributionCenters } = useFilters()
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { data, companieId } = useReabRoutes()
  const { data: dataVeichule } = useReabTypeVeichule()
  function convertArray(data: any[]): any[] {
    return data.map(item => ({
      value: item['id-id'],
      label: item['veic-nome']
    }))
  }

  const typeReabs = [
    { value: 1, label: 'Ferragem' },
    { value: 2, label: 'Chaparia' }
  ]
  const diaSemanas = [
    { value: 1, label: 'Segunda-feira' },
    { value: 2, label: 'Terça-feira' },
    { value: 3, label: 'Quarta-feira' },
    { value: 4, label: 'Quinta-feira' },
    { value: 5, label: 'Sexta-feira' }
  ]

  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          isDisabled={companieId === ''}
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={() => {
          onClose()
          clearParams()
        }}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <FaTruck />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0 ? 'Editar Rotas' : 'Criar Rotas'}
              </Box>
            </Flex>
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <br></br>
            <FormControl isRequired>
              <Filter
                label="CD Origem *"
                options={distributionCenters}
                isMulti={false}
                isDisabled={selected !== 0}
                // isDisabled={selecteds.length > 0}
                value={paramsEdit.centroId}
                onChange={value =>
                  handleUpdateEditParams({ name: 'centroId', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <Filter
                label="Lojas *"
                options={centers}
                isMulti={true}
                value={paramsEdit.lojaId}
                onChange={value =>
                  handleUpdateEditParams({ name: 'lojaId', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <Filter
                label="Tipo Cronograma *"
                options={typeReabs}
                isMulti={false}
                value={paramsEdit.tipo}
                onChange={value =>
                  handleUpdateEditParams({ name: 'tipo', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <Filter
                label="Veículo"
                options={convertArray(dataVeichule)}
                isMulti={false}
                // isDisabled={selecteds.length > 0}
                value={paramsEdit.veiculo}
                onChange={value =>
                  handleUpdateEditParams({ name: 'veiculo', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <Filter
                label="Dia da Semana"
                options={diaSemanas}
                isMulti={true}
                // isDisabled={selecteds.length > 0}
                value={paramsEdit.diaSemana}
                onChange={value =>
                  handleUpdateEditParams({ name: 'diaSemana', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>

            <FormControl isRequired>
              <FormLabel> Agrupar</FormLabel>

              <RadioGroup
                value={paramsEdit.agrupar}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'agrupar',
                    value: value
                  })
                }
              >
                <Stack direction="row">
                  <Radio
                    sx={{
                      borderColor: 'gray.500'
                    }}
                    value="1"
                  >
                    Sim
                  </Radio>
                  <Radio
                    sx={{
                      borderColor: 'gray.500'
                    }}
                    value="2"
                  >
                    Nao
                  </Radio>
                </Stack>
              </RadioGroup>
            </FormControl>
            <br></br>
            <FormControl>
              <FormLabel> Carga Especial</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.carga}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'carga',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                onClose()
                clearParams()
              }}
            >
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              isDisabled={
                paramsEdit.diaSemana === '' ||
                paramsEdit.centroId === '' ||
                paramsEdit.lojaId === '' ||
                paramsEdit.tipo === '' ||
                paramsEdit.veiculo === ''
              }
              onClick={() => {
                if (selected !== 0) {
                  createData()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ReabRoutesCreate
